export default __webpack_public_path__ + "static/media/r_wdt_c_4.db3b43c6.mp3";